import React from 'react';
import { Tabs } from 'antd';
import PurchaseCart from './components/purchaseCart';
import CpmCart from './components/cpmCart';
import CpmPurchaseCart from './components/cpmPurchaseCart';
export default function Cart() {
  const items = [
    { label: '订货清单', key: '1', children: <PurchaseCart /> }, // 务必填写 key
    { label: 'CPM销售订货清单', key: '2', children: <CpmCart /> },
    { label: 'CPM销售采购清单', key: '3', children: <CpmPurchaseCart /> },
  ];

  return (
    <Tabs defaultActiveKey="1" items={items}>
      {/* <Tabs.TabPane tab="订货清单" key="1">
        <PurchaseCart />
      </Tabs.TabPane>
      <Tabs.TabPane tab="CPM销售订货清单" key="2">
        <CpmCart />
      </Tabs.TabPane>
      <Tabs.TabPane tab="CPM销售采购清单" key="3">
        <CpmPurchaseCart />
      </Tabs.TabPane> */}
    </Tabs>
  );
}
